import {Validators} from '@angular/forms';

import {
  ADDRESS_MAX_LENGTH,
  BUILDING_VALIDATION,
  DISTRICT_VALIDATION,
  MIN_LENGTH,
  NAME_MAX_LENGTH,
  NAME_VALIDATION,
  ONLY_NUMBERS_VALIDATION,
  ZIP_LENGTH,
} from 'src/utils/constants';
import {FORM_FIELDS_NAMES} from "../enums";

export const VALIDATIONS = {
  [FORM_FIELDS_NAMES.CITY]: [
    Validators.minLength(MIN_LENGTH),
    Validators.maxLength(ADDRESS_MAX_LENGTH),
    Validators.pattern(NAME_VALIDATION),
  ],
  [FORM_FIELDS_NAMES.FIRST_NAME]: [
    Validators.minLength(MIN_LENGTH),
    Validators.maxLength(NAME_MAX_LENGTH),
    Validators.pattern(NAME_VALIDATION),
  ],
  [FORM_FIELDS_NAMES.STREET]: [
    Validators.minLength(MIN_LENGTH),
    Validators.maxLength(ADDRESS_MAX_LENGTH),
    Validators.pattern(BUILDING_VALIDATION),
  ],
  [FORM_FIELDS_NAMES.BUILDING]: [
    Validators.minLength(1),
    Validators.maxLength(ADDRESS_MAX_LENGTH),
    Validators.pattern(BUILDING_VALIDATION),
  ],
  [FORM_FIELDS_NAMES.TIN]: [
    Validators.minLength(10),
    Validators.maxLength(10),
    Validators.pattern(ONLY_NUMBERS_VALIDATION),
  ],
  [FORM_FIELDS_NAMES.ZIP_CODE]: [
    Validators.minLength(ZIP_LENGTH),
    Validators.maxLength(ZIP_LENGTH),
    Validators.pattern(ONLY_NUMBERS_VALIDATION),
  ],
  region: [
    Validators.required,
    Validators.minLength(MIN_LENGTH),
    Validators.pattern(DISTRICT_VALIDATION),
  ],
};
